module.exports = __webpack_public_path__ + "static/media/globe-europe.3561b857.svg";